// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import PostFormPubMed from "./components/PostFormPubMed";
import PostFormPubMedPlus from "./components/PostFormPubMedPlus";
import PostFormArxiv from "./components/PostFormArxiv";
import PostFormUtils from "./components/PostFormUtils";
import Login from "./components/Login"
import Dashboard from "./components/Dashboard";


const App = () => {

  const isLoggedIn = sessionStorage.getItem("isLoggedIn");

  return (
    <Router>
      <Routes>
        <Route path="/" element={isLoggedIn ? <Dashboard /> : <Login />} />
        <Route path="/login" element={isLoggedIn ? <Dashboard /> : <Login />} />
        <Route path="/dashboard" element={isLoggedIn ? <Dashboard /> : <Login />} />
        <Route element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />}>
          <Route path="/pubmed" element={<PostFormPubMed />} />
          <Route path="/pubmed_plus" element={<PostFormPubMedPlus />} />
          <Route path="/arxiv" element={<PostFormArxiv />} />
          <Route path="/utils" element={<PostFormUtils />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
